import type { ColDef, ColGroupDef } from "ag-grid-community";
import { useMemo } from "react";

import { getProductArea, type Product } from "@/shared/models/Product";

type PerforationRow = {
	HoleSizeType: number | null;
	HoleDetail: string | null;
	HolePart: string | null;
	ButtonDetail: string | null;
	ButtonPart: string | null;
};

const PERFORATION_COLUMN_DEFS: (ColDef | ColGroupDef)[] = [
	{
		headerName: "Hole",
		children: [
			{ field: "HoleSizeType", headerName: "Size", flex: 2, minWidth: 60 },
			{ field: "HoleDetail", headerName: "Det.", flex: 1.5, minWidth: 55 },
			{ field: "HolePart", headerName: "Punch P#", flex: 4, minWidth: 85 },
		],
	},
	{
		headerName: "Button",
		children: [
			{ field: "ButtonDetail", headerName: "Det.", flex: 1.5, minWidth: 55 },
			{ field: "ButtonPart", headerName: "Button P#", flex: 5, minWidth: 90 },
		],
	},
];

export const usePerforationsTableData = (product: Product | null) => {
	const rowData = useMemo<PerforationRow[]>(() => {
		if (!product || getProductArea(product) !== "punch") return [];
		const holes = product.Perforations.filter(
			(p) => p.PerforationType === "HOLE",
		).sort((a, b) => a.SequenceOrder - b.SequenceOrder);
		const buttons = product.Perforations.filter(
			(p) => p.PerforationType === "BUTTON",
		).sort((a, b) => a.SequenceOrder - b.SequenceOrder);
		const rowCount = Math.max(holes.length, buttons.length);
		const rows: PerforationRow[] = [];
		for (let i = 0; i < rowCount; i++) {
			const h = holes[i];
			const b = buttons[i];
			rows.push({
				HoleSizeType: h?.HoleSize ?? null,
				HoleDetail: h?.DetailNumber ?? null,
				HolePart: h?.PunchPartNumber ?? null,
				ButtonDetail: b?.DetailNumber ?? null,
				ButtonPart: b?.ButtonPartNumber ?? null,
			});
		}
		return rows;
	}, [product]);

	return { columnDefs: PERFORATION_COLUMN_DEFS, rowData };
};
